/**
 * Toast Utility for Man & Machine
 * Provides consistent toast notifications with proper styling
 */
import { toast as baseToast } from '@/hooks/use-toast';
import {
  CheckCircle,
  Info,
  WarningCircle,
  XCircle
} from '@phosphor-icons/react';

const toastStyles = {
  success: {
    className: "border-green-500/50 bg-green-500/10 text-green-500",
    icon: CheckCircle,
    duration: 4000,
  },
  error: {
    className: "border-red-500/50 bg-red-500/10 text-red-500",
    icon: XCircle,
    duration: 8000,
  },
  warning: {
    className: "border-yellow-500/50 bg-yellow-500/10 text-yellow-500",
    icon: WarningCircle,
    duration: 6000,
  },
  info: {
    className: "border-blue-500/50 bg-blue-500/10 text-blue-500",
    icon: Info,
    duration: 5000,
  },
};

export const toast = {
  success: (title, description) => {
    const { className, icon: Icon, duration } = toastStyles.success;
    return baseToast({
      title: (
        <div className="flex items-center gap-2">
          <Icon size={16} />
          <span>{title}</span>
        </div>
      ),
      description,
      className,
      duration,
    });
  },

  error: (title, description) => {
    const { className, icon: Icon, duration } = toastStyles.error;
    return baseToast({
      title: (
        <div className="flex items-center gap-2">
          <Icon size={16} />
          <span>{title}</span>
        </div>
      ),
      description,
      className,
      duration,
    });
  },

  warning: (title, description) => {
    const { className, icon: Icon, duration } = toastStyles.warning;
    return baseToast({
      title: (
        <div className="flex items-center gap-2">
          <Icon size={16} />
          <span>{title}</span>
        </div>
      ),
      description,
      className,
      duration,
    });
  },

  info: (title, description) => {
    const { className, icon: Icon, duration } = toastStyles.info;
    return baseToast({
      title: (
        <div className="flex items-center gap-2">
          <Icon size={16} />
          <span>{title}</span>
        </div>
      ),
      description,
      className,
      duration,
    });
  },

  // Shorthand for common operations
  created: (itemName) => toast.success('Created', `${itemName} has been created successfully.`),
  updated: (itemName) => toast.success('Updated', `${itemName} has been updated successfully.`),
  deleted: (itemName) => toast.success('Deleted', `${itemName} has been deleted successfully.`),
  activated: (itemName) => toast.success('Activated', `${itemName} is now active.`),
  paused: (itemName) => toast.success('Paused', `${itemName} has been paused.`),
  saved: (itemName) => toast.success('Saved', `${itemName} has been saved successfully.`),
  
  apiError: (operation) => toast.error('Error', `Failed to ${operation}. Please try again.`),
};

export default toast;
